import ModuleManager from "../../framework/core/module_manager";

export default class SdkBase{

    private _name : string;
    public get name() : string {
        return this._name;
    }    

    constructor(name : string){

        this._name = name;
    }

    public checkLogin(jsonParam : string): boolean{

        let jsonObject =  JSON.parse(jsonParam);  

        if (jsonObject && jsonObject.error) {
            
            ModuleManager.instance.hideModule("NetPrompt");
            let error : string = jsonObject.error
            if (error && (error == "login cancel" || error.includes("Cancel"))) {
            } else {
                ModuleManager.instance.toast(jsonObject.error);
            }
            return false;
        }

        return true;

    }
}